import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio? OhPyO? OhPyOh?" mdxType="Seo" />
    <h1 {...{
      "id": "why-not-ohpyo"
    }}>{`Why not OhPyO?`}</h1>
    <p><a parentName="p" {...{
        "href": "https://mail.python.org/pipermail/centraloh/2008-March/000082.html",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Names were proposed`}</a>{`. `}<a parentName="p" {...{
        "href": "https://mail.python.org/pipermail/centraloh/2008-March/thread.html#82",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`There was a discussion`}</a>{`. `}<a parentName="p" {...{
        "href": "https://mail.python.org/pipermail/centraloh/2008-March/000086.html",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`There was a vote`}</a>{`. `}<a parentName="p" {...{
        "href": "https://mail.python.org/pipermail/centraloh/2008-March/000088.html",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`PyOhio was born`}</a>{`!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      